import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Market Area Name',
    field: 'marketAreaName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'County',
    field: 'countyNames',
    filter: 'text',
    searchable: true,
  },
];
